// extracted by mini-css-extract-plugin
module.exports = {"c-pointer":"Products_c-pointer__1Vt1i","action-icon":"Products_action-icon__qrKhd"};